// Check for disallowed characters (CJK, Thai, Cyrillic)
const DISALLOWED_CHARACTER_RANGES = [
  /* CJK Symbols & Punctuation */
  [0x3000, 0x303f],

  /* Japanese */
  [0x3040, 0x309f], // Hiragana
  [0x30a0, 0x30ff], // Katakana
  [0x31f0, 0x31ff], // Katakana Phonetic Extensions

  /* Chinese (also used in Japanese Kanji) */
  [0x3400, 0x4dbf], // CJK Unified Ideographs Ext-A
  [0x4e00, 0x9fff], // CJK Unified Ideographs
  [0xf900, 0xfaff], // CJK Compatibility Ideographs
  [0x20000, 0x2a6df], // Ext-B
  [0x2a700, 0x2b73f], // Ext-C
  [0x2b740, 0x2b81f], // Ext-D
  [0x2b820, 0x2ceaf], // Ext-E
  [0x2ceb0, 0x2ebef], // Ext-F

  /* Korean */
  [0x1100, 0x11ff], // Hangul Jamo
  [0x3130, 0x318f], // Hangul Compatibility Jamo
  [0xac00, 0xd7a3], // Hangul Syllables

  /* Thai */
  [0x0e00, 0x0e7f], // Thai

  /* Cyrillic */
  [0x0400, 0x04ff], // Cyrillic (Main block)
];

export const DISALLOWED_CHARACTERS_ERROR_MESSAGE =
  "Please use English letters and numbers only.";

const isDisallowedCodePoint = (cp) => {
  for (const [from, to] of DISALLOWED_CHARACTER_RANGES) {
    if (cp >= from && cp <= to) return true;
  }
  return false;
};

export const textHasDisallowedCharacters = (text) => {
  for (const char of text) {
    const cp = char.codePointAt(0);
    if (isDisallowedCodePoint(cp)) return true;
  }
  return false;
};
